import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Button from "../components/common/Button";
import { useAuth } from "../context/AuthContext";
import { consumeAuthNotice } from "../services/authStorage";

export default function LoginPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();
  const [form, setForm] = useState({
    identifier: "",
    password: "",
    rememberMe: true,
  });
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const authNotice = consumeAuthNotice();

    if (authNotice) {
      setError(authNotice);
    }
  }, []);

  const canSubmit =
    form.identifier.trim().length > 0 && form.password.trim().length > 0;
  const redirectPath = location.state?.from || "/dashboard";

  return (
    <div className="login-shell">
      <div className="login-panel">
        <div className="login-brand">
          <img
            className="login-brand-logo"
            src="/calling-logo.svg"
            alt="Calling"
          />
        </div>

        <div className="login-copy">
          <div className="section-title section-title-no-margin">Sign In</div>
          <p className="page-subtitle">
            Access the Calling workspace, live campaigns, and agent operations
            using your current account.
          </p>
        </div>

        <form
          className="login-form"
          onSubmit={async (event) => {
            event.preventDefault();

            if (!canSubmit || submitting) {
              return;
            }

            setSubmitting(true);
            setError("");

            try {
              await login(form);
              navigate(redirectPath, { replace: true });
            } catch (errorValue) {
              setError(errorValue?.message || "Unable to sign in right now.");
            } finally {
              setSubmitting(false);
            }
          }}
        >
          <label className="login-field">
            <span className="login-label">Email or Username</span>
            <input
              type="text"
              className="login-input"
              value={form.identifier}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  identifier: event.target.value,
                }))
              }
              placeholder="Enter your email or username"
              autoComplete="username"
            />
          </label>

          <label className="login-field">
            <span className="login-label">Password</span>
            <input
              type="password"
              className="login-input"
              value={form.password}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  password: event.target.value,
                }))
              }
              placeholder="Enter your password"
              autoComplete="current-password"
            />
          </label>

          <label className="login-check">
            <input
              type="checkbox"
              checked={form.rememberMe}
              onChange={(event) =>
                setForm((current) => ({
                  ...current,
                  rememberMe: event.target.checked,
                }))
              }
            />
            <span>Remember me on this device</span>
          </label>

          <div className={`login-feedback ${error ? "error" : ""}`.trim()}>
            {error || "Sign in with your dashboard account."}
          </div>

          <Button
            type="submit"
            variant="gold"
            className="login-submit"
            disabled={!canSubmit || submitting}
          >
            {submitting ? "Signing In..." : "Sign In"}
          </Button>
        </form>
      </div>
    </div>
  );
}
